export default __webpack_public_path__ + "static/summer_containers32-7297d1652e4284e55f9b87ed0848ee71.webp";